import React from "react";

/**
 * BioDivider — slim animated DNA / vine divider used between sections.
 * Hooks into the existing brand palette via CSS vars.
 */
export const BioDivider = ({ variant = "helix" }) => {
    if (variant === "vine") {
        return (
            <div
                aria-hidden
                data-testid="bio-divider-vine"
                className="relative w-full h-10 overflow-hidden pointer-events-none"
            >
                <svg
                    viewBox="0 0 1200 40"
                    preserveAspectRatio="none"
                    className="w-full h-full"
                >
                    <path
                        d="M0 20 Q 150 0 300 20 T 600 20 T 900 20 T 1200 20"
                        stroke="hsl(var(--brand-copper))"
                        strokeWidth="1.2"
                        fill="none"
                        opacity="0.5"
                        strokeDasharray="4 6"
                    />
                    {[150, 300, 600, 900, 1050].map((cx, i) => (
                        <g key={i} transform={`translate(${cx}, 12)`}>
                            <path
                                d="M0 0 C -6 -3 -10 -8 -8 -16 C -2 -16 4 -12 6 -4 C 4 -2 2 0 0 0 Z"
                                fill="hsl(var(--brand-moss))"
                                opacity="0.55"
                            />
                        </g>
                    ))}
                </svg>
            </div>
        );
    }

    return (
        <div
            aria-hidden
            data-testid="bio-divider-helix"
            className="relative w-full h-14 overflow-hidden pointer-events-none"
        >
            <svg
                viewBox="0 0 1200 80"
                preserveAspectRatio="none"
                className="w-full h-full"
            >
                {/* DNA double-helix wave */}
                <path
                    d="M0 40 Q 75 0 150 40 T 300 40 T 450 40 T 600 40 T 750 40 T 900 40 T 1050 40 T 1200 40"
                    stroke="hsl(var(--brand-copper))"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    fill="none"
                    opacity="0.55"
                />
                <path
                    d="M0 40 Q 75 80 150 40 T 300 40 T 450 40 T 600 40 T 750 40 T 900 40 T 1050 40 T 1200 40"
                    stroke="hsl(var(--brand-moss))"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    fill="none"
                    opacity="0.5"
                />
                {/* base-pair rungs */}
                {Array.from({ length: 16 }).map((_, i) => {
                    const x = (1200 / 16) * i + 1200 / 32;
                    const sin = Math.sin(((x / 1200) * Math.PI) * 8);
                    const y1 = 40 - sin * 28;
                    const y2 = 40 + sin * 28;
                    return (
                        <line
                            key={i}
                            x1={x}
                            x2={x}
                            y1={y1}
                            y2={y2}
                            stroke="hsl(var(--brand-copper))"
                            strokeWidth="1"
                            strokeLinecap="round"
                            opacity="0.4"
                        />
                    );
                })}
            </svg>
        </div>
    );
};

export default BioDivider;
